import { formatISO } from 'date-fns';
import { isDate as fnsIsDate } from 'date-fns/isDate';
import { DateRangeInterface } from '../models/date-range/date-range.interface';
import { DateRange } from '../models/date-range/date-range.model';
import { PlainRangeInterface } from '../models/range.interface';
import { TsRangeInterface } from '../models/ts-range/ts-range.interface';
import { TsRange } from '../models/ts-range/ts-range.model';
import { isDateRangeInterface } from './is-date-range.function';

export function dateRangeInterfaceToModel<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
  RangeType extends Date = Date,
  PlainType extends string | number = string,
  StartType extends RangeType | null = StartBoundary extends 'finite'
    ? RangeType
    : RangeType | null,
  EndType extends RangeType | null = EndBoundary extends 'finite' ? RangeType : RangeType | null,
  PlainStartType extends PlainType | null = StartBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  PlainEndType extends PlainType | null = EndBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
>(
  value: PlainRangeInterface<StartBoundary, EndBoundary, PlainType, PlainStartType, PlainEndType>,
):
  | TsRange<
      StartBoundary,
      EndBoundary,
      RangeType,
      PlainType,
      StartType,
      EndType,
      PlainStartType,
      PlainEndType
    >
  | DateRange<
      StartBoundary,
      EndBoundary,
      RangeType,
      PlainType,
      StartType,
      EndType,
      PlainStartType,
      PlainEndType
    >;
export function dateRangeInterfaceToModel<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
  RangeType extends Date = Date,
  PlainType extends string | number = string,
  StartType extends RangeType | null = StartBoundary extends 'finite'
    ? RangeType
    : RangeType | null,
  EndType extends RangeType | null = EndBoundary extends 'finite' ? RangeType : RangeType | null,
  PlainStartType extends PlainType | null = StartBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  PlainEndType extends PlainType | null = EndBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
>(
  value: DateRangeInterface<StartBoundary, EndBoundary, RangeType, StartType, EndType>,
): DateRange<
  StartBoundary,
  EndBoundary,
  RangeType,
  PlainType,
  StartType,
  EndType,
  PlainStartType,
  PlainEndType
>;
export function dateRangeInterfaceToModel<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
  RangeType extends Date = Date,
  PlainType extends string | number = string,
  StartType extends RangeType | null = StartBoundary extends 'finite'
    ? RangeType
    : RangeType | null,
  EndType extends RangeType | null = EndBoundary extends 'finite' ? RangeType : RangeType | null,
  PlainStartType extends PlainType | null = StartBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  PlainEndType extends PlainType | null = EndBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
>(
  value: TsRangeInterface<StartBoundary, EndBoundary, RangeType, StartType, EndType>,
): TsRange<
  StartBoundary,
  EndBoundary,
  RangeType,
  PlainType,
  StartType,
  EndType,
  PlainStartType,
  PlainEndType
>;
export function dateRangeInterfaceToModel<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
  PlainType extends string | number = string,
  PlainStartType extends PlainType | null = StartBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  PlainEndType extends PlainType | null = EndBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
>(
  value:
    | DateRangeInterface<StartBoundary, EndBoundary, Date, Date | null, Date | null>
    | TsRangeInterface<StartBoundary, EndBoundary, Date, Date | null, Date | null>
    | PlainRangeInterface<StartBoundary, EndBoundary, PlainType, PlainStartType, PlainEndType>,
) {
  if (isDateRangeInterface(value)) {
    return DateRange.fromObject(value);
  }
  const plain = value;
  return TsRange.fromObject({
    ...plain,
    start: fnsIsDate(plain.start) ? formatISO(plain.start) : plain.start,
    end: fnsIsDate(plain.end) ? formatISO(plain.end) : plain.end,
  });
}
